const INTERV=0.5
const FSIZE=0.352778
const TSIZE=0.52
const TSIZE2=0.49
const TSIZE3=0.45

export async function print_rawbt(data){
    const koef=8
    const canvas = document.createElement('canvas')
    canvas.width=data.width*koef
    canvas.height=data.height*koef
    const ctx = canvas.getContext('2d')
    ctx.fillStyle='#000000'
    ctx.globalAlpha=1.0;
    for(let i=0;i<data.data.length;i++){
        const el=data.data[i]
        if(el.type==='text') {
            ctx.font = ''+(el.style.fontWeight?'bold ':'')+(el.style.fontStyle?'italic ':'')+parseFloat(el.style.fontSize)*koef+'px '+el.style.fontFamily          //"48px serif"
            ctx.textAlign = el.style.textAnchor==='middle'?'center':el.style.textAnchor
            ctx.fillText(el.text, el.x*koef, el.y*koef)
        }
        else if(el.type==='line') {
            ctx.beginPath()
            ctx.moveTo(el.x1*koef, el.y1*koef)
            ctx.lineTo(el.x2*koef, el.y2*koef)
            ctx.stroke()
        }
        else if(el.type==='rect') {
            ctx.fillRect(el.x*koef,el.y*koef,el.width*koef,el.height*koef);
        }
        else if(el.type==='img') {
            const image = new Image()
            image.src=el.src
            /*image.onload = function() {
            ctx.drawImage(image, el.x*koef, el.y*koef, el.width*koef, el.height*koef)
            }*/
            await image.decode()
            ctx.drawImage(image, el.x*koef, el.y*koef, el.width*koef, el.height*koef)
        }
    }
    //)
    let imageDataURL=await Promise.resolve(canvas.toDataURL())
    const data_to_print='rawbt:'+imageDataURL
    window.location.href=data_to_print
    //const link=document.createElement('a')
    //link.href=data_to_print
    //setTimeout(()=>link.click(),100)
}

export function printer_job(prn_type,data,print_cmd=true){
    if(prn_type===1){
        if(!data.department) return null
        if(!data.department.printer) return null
        if(!data.department.printer.templates) return null
        const templates=data.department.printer.templates
        const tmpl=get_template('Kitchen.prn',templates)
        if(!tmpl) return null
        const arr_print=[]
        const print_data={font_nam:'Arial',font_size:3.53,curr_x:0,curr_y:0,max_x:0,max_y:0,max_height:0}
        data.department=data.department.name
        if(tmpl['header2']&&data.comment) print_sec(arr_print,print_data,fill_values(data,tmpl['header2'],false),templates)
        else print_sec(arr_print,print_data,fill_values(data,tmpl['header'],false),templates)
        if(data['docTable']){
            data['docTable'].forEach(item=>{
                print_sec(arr_print,print_data,fill_values(item,tmpl['row'],false),templates)
                if(item['comment']) print_sec(arr_print,print_data,fill_values(item,tmpl['coment'],false),templates)
            })
        }
        print_sec(arr_print,print_data,fill_values(data,tmpl['footer'],false),templates)
        return {type:'svg',width:print_data['max_x'],height:print_data['max_y'],data:arr_print,print_cmd}
    } else if(prn_type===2){
        if(!data.printer) return null
        if(!data.printer.templates) return null
        data.author=data.author.fio
        const templates=data.printer.templates
        const tmpl=get_template('Precheck.prn',templates)
        if(!tmpl) return null
        const arr_print=[]
        const print_data={font_nam:'Arial',font_size:3.53,curr_x:0,curr_y:0,max_x:0,max_y:0,max_height:0}
        if(data['docType'] && parseInt(data['docType'])===1){
            if(tmpl['delivery']) print_sec(arr_print,print_data,fill_values(data,tmpl['delivery'],false),templates)
        }
        print_sec(arr_print,print_data,fill_values(data,tmpl['header'],false),templates)
        if(data['docTable']){
            data['docTable'].forEach(item=>{
                print_sec(arr_print,print_data,fill_values(item,tmpl['row'],false),templates)
            })
        }
        if(parseFloat(data['sumd'])!==0) print_sec(arr_print,print_data,fill_values(data,tmpl['discount'],false),templates)
        if(parseFloat(data['sumt'])!==0) print_sec(arr_print,print_data,fill_values(data,tmpl['totall'],false),templates)
        print_sec(arr_print,print_data,fill_values(data,tmpl['footer'],false),templates)
        return {type:'svg',width:print_data['max_x'],height:print_data['max_y'],data:arr_print,print_cmd}
    }else if(prn_type===6){
        if(!data.department) return null
        if(!data.department.printer) return null
        if(!data.department.printer.templates) return null
        const templates=data.department.printer.templates
        const tmpl=get_template('Refuse.prn',templates)
        if(!tmpl) return null
        const arr_print=[]
        const print_data={font_nam:'Arial',font_size:3.53,curr_x:0,curr_y:0,max_x:0,max_y:0,max_height:0}
        data.department=data.department.name
        print_sec(arr_print,print_data,fill_values(data,tmpl['header'],false),templates)
        if(data['docTable']){
            data['docTable'].forEach(item=>{
                print_sec(arr_print,print_data,fill_values(item,tmpl['row'],false),templates)
                if(item['comment']) print_sec(arr_print,print_data,fill_values(item,tmpl['coment'],false),templates)
            })
        }
        print_sec(arr_print,print_data,fill_values(data,tmpl['footer'],false),templates)
        return {type:'svg',width:print_data['max_x'],height:print_data['max_y'],data:arr_print,print_cmd}
    }
    return null
}

function decode64(input) {
    const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/= "
    const win1251decoder = new TextDecoder("windows-1251");
    let output = ''
    let buffer = []
    let chr1, chr2, chr3 = ''
    let enc1, enc2, enc3, enc4 = ''
    let i = 0
    input = input.replace(/ /g, '+')
    do {
        let buffer1 = []
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output = output + String.fromCharCode(chr1);
        buffer.push(chr1)
        buffer1.push(chr1)

        if (enc3 !== 64) {
            output = output + String.fromCharCode(chr2);
            buffer.push(chr2)
            buffer1.push(chr2)
        }
        if (enc4 !== 64) {
            output = output + String.fromCharCode(chr3);
            buffer.push(chr3)
            buffer1.push(chr3)
        }
       chr1 = chr2 = chr3 = "";
       enc1 = enc2 = enc3 = enc4 = "";

    } while (i < input.length);

    const bytes = new Uint8Array(buffer)
    return win1251decoder.decode(bytes)
}

function get_template(name,templates){
    const raw=templates.find(el=>el.name===name)
    if(!raw) return null
    let base64 = raw.contents.substring(37)
    let arr=decode64(base64).split('#')
    arr.shift()
    const tmpl={}
    arr.forEach(el => {
        let str=el.trim()
        const pos=str.indexOf("\n")
        if(pos!==-1) tmpl[str.substring(0,pos).trim()]=str.substring(pos+1).trim()
    })
    return tmpl
}

function print_sec(arr_print,print_data,str,templates){
    const arr=str.split("\r\n")
    arr.forEach(val => print_job(arr_print,print_data,val,templates))
}

function fill_values(data,str,to_upper=true){
    let ret=''
    let pos2=str.indexOf('>')
    while(pos2!==-1){
        let pos1 = str.lastIndexOf('<',pos2)
        if(pos1===-1) break
        ret+=str.substring(0,pos1)
        let val = str.substring(pos1+1, pos2).trim()
        if(val==='CurDate') val=(new Date()).toLocaleDateString()
        else if(val==='CurTime') val=(new Date()).toLocaleTimeString()
        else if(val==='CurDateTime') val=(new Date()).toLocaleString()
        else if(data[val] && to_upper) val=data[val].toUpperCase()
        else if(data[val]) val=data[val]
        else val=''
        ret+=val
        str = str.substring(pos2+1)
        pos2=str.indexOf('>')
    }
    ret+=str
    return ret
}

function strlen_mm(str,font_size){
    const str1='"1234567890qertyuopasdfghjkzxcvbnйцукенгзхъфвапролдэячситьбюєї?()+-'
    const str2='\'.,:;il!і *'
	const arr = Array.from(str)
    let lng=0
    for(let i=0;i<arr.length;i++){
        if(!arr[i]) continue
        if(str1.indexOf(arr[i])!==-1) lng+=TSIZE2*font_size
        else if(str2.indexOf(arr[i])!==-1) lng+=TSIZE3*font_size
        else lng+=TSIZE*font_size
    }
    return lng
}

function print_job(arr_print,print_data,job,templates){
    if(!job) return
    const par = job.split('|')
    let x1,x2,x,y,y1,y2,w,height,max_height,pos,pos1=0
    let stl,str,tmp=null
    switch (par[0]) {
        case '01':  //змінити ім"я шрифта
            print_data['font_name']=par[1]
            return
        case '02':  //Змінити розмір шрифта
            print_data['font_size']=parseInt(parseInt(par[1])*FSIZE*10)/10 //1pt=0.352778mm
            return
        case '03':  //Змінини курсив, жирний, підкреслений
                    //0-норм, 1-Ж, 2-К, 3-ЖК, 4-Ч, 5-ЖЧ, 6-КЧ, 7-ЖКЧ
            if(par[1]==='1' || par[1]==='3' || par[1]==='5' || par[1]==='7') print_data['font_bold']=true
            else print_data['font_bold']=null
            if(par[1]==='2' || par[1]==='3' || par[1]==='6' || par[1]==='7') print_data['font_italic']=true
            else print_data['font_italic']=null
            if(par[1]==='4' || par[1]==='5' || par[1]==='6' || par[1]==='7') print_data['font_under']=true
            else print_data['font_under']=null
            return;
        case '04':  //Змінити товщину лінії
            
            break
        case '05':  //Зсунути вниз
            tmp=parseFloat(par[1].replace(',','.'))
            if(tmp===0) tmp=print_data['max_height']
            print_data['curr_x']=0
            print_data['curr_y']+=tmp
            if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
            print_data['max_height']=print_data['font_size']+2*INTERV
            return
        case '06':  //Горизонтальна лінія
            x1=parseFloat(par[1].replace(',','.'))
            x2=x1+parseFloat(par[2].replace(',','.'))
            y=parseInt(print_data['curr_y']*10)/10
            arr_print.push({type:'line',x1,y1:y,x2,y2:y})
            return
        case '07':  //Вертикальна лінія
            x1=parseFloat(par[1].replace(',','.'))
            y2=parseFloat(par[2].replace(',','.'))
            if(y2===0) y2=print_data['max_height']
            y=parseInt(print_data['curr_y']*10)/10
            arr_print.push({type:'line',x1,y1:y,x2:x1,y2:y+y2})
            return
        case '08':  //текст ліво
            stl={textAnchor:'start',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=x1
            y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)/10
            print_data['curr_y']=y+INTERV
            print_data['max_height']=print_data['font_size']+2*INTERV
            if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
            if(x2+INTERV>print_data['max_x']) print_data['max_x']=x2+INTERV
            str=par[3].replace(/\\n/g,' ').replace(/\\r/g,'')
            arr_print.push({type:'text',x,y,style:stl,text:str})
            return
        case '09':  //текст право
            stl={textAnchor:'end',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=x2
            y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)/10
            print_data['curr_y']=y+INTERV
            print_data['max_height']=print_data['font_size']+2*INTERV
            if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
            if(x2+INTERV>print_data['max_x']) print_data['max_x']=x2+INTERV
            str=par[3].replace(/\\n/g,' ').replace(/\\r/g,'')
            arr_print.push({type:'text',x,y,style:stl,text:str})
            return
        case '10':  //текст центр
            stl={textAnchor:'middle',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=parseInt((x1+x2/2)*10)/10
            y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)/10
            print_data['curr_y']=y+INTERV
            print_data['max_height']=print_data['font_size']+2*INTERV
            if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
            if(x2+INTERV>print_data['max_x']) print_data['max_x']=x2+INTERV
            str=par[3].replace(/\\n/g,' ').replace(/\\r/g,'')
            arr_print.push({type:'text',x,y,style:stl,text:str})
            return
        case '11':  //текст ліво з переносом
            stl={textAnchor:'start',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            height=print_data['curr_y'];
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=x1
            w=(x2-x1)
            tmp=par[3].trim()
            pos=-1
            do{
                str='';
                for(let i=0;i<tmp.length;i++){
                    str=tmp.substring(0,i+1);
                    if(strlen_mm(str,print_data['font_size'])>w) break
                }
                pos1=str.indexOf("\n")
                if(pos1!==-1) pos=pos1
                else if(strlen_mm(str,print_data['font_size'])<=w) pos=-1
                else pos=str.lastIndexOf(' ')
                if(pos!==-1){
                    str=tmp.substring(0,pos).trim()
                    tmp=tmp.substr(pos).trim()
                }
                y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)/10
                print_data['curr_y']=y+INTERV
                if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
                arr_print.push({type:'text',x,y,style:stl,text:str})
            } while(pos!==-1)
            if(x2+INTERV>print_data['max_x']) print_data['max_x']=x2+INTERV
            max_height=print_data['curr_y']-height+INTERV
            if(max_height>print_data['max_height']) print_data['max_height']=max_height
            print_data['curr_y']=height
            return
        case '12':  //текст право з переносом
            stl={textAnchor:'end',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            height=print_data['curr_y'];
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=x2
            w=(x2-x1)/(print_data['font_size']*TSIZE)
            tmp=par[3]
            pos=-1
            do{
                str=tmp.substring(0,w+1)
                pos1=str.indexOf("\n")
                if(pos1!==-1) pos=pos1
                else if(str.length<=w) pos=-1
                else pos=str.lastIndexOf(' ')
                if(pos!==-1){
                    str=tmp.substring(0,pos).trim()
                    tmp=tmp.substr(pos).trim()
                }
                y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)*10
                print_data['curr_y']=y+INTERV
                if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
                arr_print.push({type:'text',x,y,style:stl,text:str})
            } while(pos!==-1)
            if(x2+INTERV>print_data['max_x']) print_data['max_x']=x2+INTERV
            max_height=print_data['curr_y']-height;
            if(max_height>print_data['max_height']) print_data['max_height']=max_height
            print_data['curr_y']=height
            return
        case '13':  //текст центр з переносом
            stl={textAnchor:'middle',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            height=print_data['curr_y'];
            max_height=0
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=parseInt((x1+x2/2)*10)/10
            w=(x2-x1)/(print_data['font_size']*TSIZE)
            tmp=par[3]
            pos=-1
            do{
                str=tmp.substring(0,w+1)
                pos1=str.indexOf("\n")
                if(pos1!==-1) pos=pos1
                else if(str.length<=w) pos=-1
                else pos=str.lastIndexOf(' ')
                if(pos!==-1){
                    str=tmp.substring(0,pos).trim()
                    tmp=tmp.substr(pos).trim()
                }
                y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)*10
                max_height+=print_data['font_size']+2*INTERV
                print_data['curr_y']=y+INTERV
                if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
                arr_print.push({type:'text',x,y,style:stl,text:str})
            } while(pos!==-1)
            if(x2+INTERV>print_data['max_x']) print_data['max_x']=x2+INTERV
            if(max_height>print_data['max_height']) print_data['max_height']=max_height
            print_data['curr_y']=height
            return
        case '14':  //картинка
            x1=parseFloat(par[1].replace(',','.'))
            y1=print_data['curr_y']-print_data['max_height']-INTERV+parseFloat(par[2].replace(',','.'))
            x2=parseFloat(par[3].replace(',','.'))
            y2=print_data['curr_y']-print_data['max_height']-INTERV+parseFloat(par[4].replace(',','.'))
            const raw=templates.find(el=>el.name===par[5])
            if(!raw) return
            arr_print.push({type:'img',x:x1,y:y1,width:x2,height:y2,src:raw.contents.replace(/ /g, '+')})
            /*$path=__DIR__ .DIRECTORY_SEPARATOR.$par[5];
            $type = pathinfo($path, PATHINFO_EXTENSION);
            $data = file_get_contents($path);
            $base64 = 'data:image/' . $type . ';base64,' . base64_encode($data);  
            arr_print.push({type:'img',x:x1,y:y1,width:x2,height:y2,src:base64})  */        
            return
        case '15':  //текст ліво в той же рядок
            stl={textAnchor:'start',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=x1
            w=(x2-x1)/(print_data['font_size']*TSIZE)
            str=par[3].substring(0,parseInt(w))
            y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)/10
            max_height=y-print_data['curr_y']+INTERV
            if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
            arr_print.push({type:'text',x,y,style:stl,text:str})
            if(x2>print_data['max_x']) print_data['max_x']=x2
            if(max_height>print_data['max_height']) print_data['max_height']=max_height
            return
        case '16':  //текст право в той же рядок
            stl={textAnchor:'end',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=x2
            w=(x2-x1)/(print_data['font_size']*TSIZE)
            str=par[3].substring(-parseInt(w))
            y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)/10
            max_height=y-print_data['curr_y']+INTERV
            if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
            arr_print.push({type:'text',x,y,style:stl,text:str})
            if(x2>print_data['max_x']) print_data['max_x']=x2
            if(max_height>print_data['max_height']) print_data['max_height']=max_height
            return
        case '17':  //текст центр в той же рядок
            stl={textAnchor:'middle',fontFamily:print_data['font_name'],fontSize:print_data['font_size']+'px'}
            if(print_data['font_bold']) stl['fontWeight']='bold'
            if(print_data['font_italic']) stl['fontStyle']='italic'
            if(print_data['font_under']) stl['textDecoration']='underline'
            height=print_data['curr_y']
            x1=parseFloat(par[1].replace(',','.'))+INTERV
            x2=parseFloat(par[2].replace(',','.'))+x1-INTERV*2
            x=(x1+x2)/2
            w=(x2-x1)-1
            str=par[3];
            while(strlen_mm(str,print_data['font_size'])>w && str.length>1) str=str.substring(1,str.length-2)
            y=parseInt((print_data['curr_y']+print_data['font_size']+INTERV)*10)/10
            max_height=y-print_data['curr_y']+INTERV
            if(print_data['curr_y']>print_data['max_y']) print_data['max_y']=print_data['curr_y']
            arr_print.push({type:'text',x,y,style:stl,text:str})
            if(x2>print_data['max_x']) print_data['max_x']=x2
            if(max_height>print_data['max_height']) print_data['max_height']=max_height
            return
        case '18':  //обнулити висоту рядка
            print_data['max_height']=0
            return;
        /*case '19':  //QR код
            $qr=new QRCode($par[3]);
            $code=$qr->raw();
            $x0=floatval(str_replace(',','.',$par[1]));
            $y0=$print_data['curr_y']+INTERV;
            $bl_s=floatval(str_replace(',','.',$par[2]))/$code['s'][0];
            foreach ($code['b'] as $y => $row) {
                $w=0;$x1=0;
                foreach ($row as $x => $val) {
                    if ($val) {
                        if($w==0) $x1=$x;
                        $w++;
                    }
                    else if($w!=0){
                        $arr_print[]=array('type'=>'rect','x'=>round($x0+$x1*$bl_s,1),'y'=>round($y0+$y*$bl_s,1),'width'=>round($w*$bl_s,1),'height'=>round($bl_s,1));
                        $w=0;
                    }
                }
                if($w!=0) $arr_print[]=array('type'=>'rect','x'=>round($x0+$x1*$bl_s,1),'y'=>round($y0+$y*$bl_s,1),'width'=>round($w*$bl_s,1),'height'=>round($bl_s,1));
            }
            $print_data['curr_y']+=$par[2]+2*INTERV;
            if($print_data['curr_y']>$print_data['max_y']) $print_data['max_y']=$print_data['curr_y'];
            return;*/
        default:
            return job
    }
}
